import IconOverflow from '@apollo/icons/default/IconOverflow.svg';
import {
  IconButton,
  Menu,
  MenuButton,
  MenuContent,
  MenuItem,
  MenuList,
} from '@apollo/orbit';
import React, { useState } from 'react';

import { PermissionGuard } from 'src/components/permissionGuards/permissionGuard/PermissionGuard';

import { PersistedQueryDeleteModal } from './persistedQueryDeleteModal/PersistedQueryDeleteModal';
import { PersistedQueryDetailsModal } from './persistedQueryDetailsModal/PersistedQueryDetailsModal';

interface Props {
  graphId: string;
  listId: string;
  persistedQueryId: string;
  clientName: string | null;
}

type OpenModalState = 'DETAILS' | 'DELETE';

export const PersistedQueryActionsMenu = ({
  graphId,
  listId,
  persistedQueryId,
  clientName,
}: Props) => {
  const [openModalState, setOpenModalState] = useState<OpenModalState | null>(
    null,
  );

  return (
    <>
      <Menu placement="bottom-end" autoSelect={false}>
        <MenuButton
          as={IconButton}
          variant="secondary"
          aria-label="Show all actions"
        >
          <IconOverflow />
        </MenuButton>
        <MenuContent>
          <MenuList>
            <MenuItem
              onClick={() => setOpenModalState('DETAILS')}
              data-analytics-category="Persisted Queries"
              data-analytics-label="action op details"
            >
              View Operation Details
            </MenuItem>
            <PermissionGuard
              graphId={graphId}
              graphPermissions="canManagePersistedQueryLists"
              fallback={null}
            >
              <MenuItem
                className="text-error hover:bg-error hover:text-error"
                onClick={() => setOpenModalState('DELETE')}
                data-analytics-category="Persisted Queries"
                data-analytics-label="action menu op delete"
              >
                Delete
              </MenuItem>
            </PermissionGuard>
          </MenuList>
        </MenuContent>
      </Menu>
      {openModalState === 'DETAILS' && (
        <PersistedQueryDetailsModal
          graphId={graphId}
          listId={listId}
          pqId={persistedQueryId}
          clientName={clientName}
          onClose={() => setOpenModalState(null)}
        />
      )}
      {openModalState === 'DELETE' && (
        <PersistedQueryDeleteModal
          isOpen
          graphId={graphId}
          listId={listId}
          persistedQueryIdToRemove={persistedQueryId}
          persistedQueryClientNameToRemove={clientName}
          onClose={() => setOpenModalState(null)}
        />
      )}
    </>
  );
};
